import { BifrostBackendNestApi, BifrostBackendViaCdnApiV2 } from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";

const GlobalVersionProvider = {
	async findAll(useApiCdnCaching) {
		const res = await (useApiCdnCaching ? BifrostBackendViaCdnApiV2 : BifrostBackendNestApi).get("/global-versions", {
			params: {
				tenantId: appConfig.tenantId
			}
		})
		// TODO: added error handling here, so FE doesn't break when global versions endpoint is not available
		// Apple store validation needs this forward-compatibility for Sunset production env.
			.catch(err => {
				if(err && err.response && err.response.status === 404) {
					return { data: [] };
				}

				throw err;
			});

		return res.data;
	}
};

export default Object.freeze(GlobalVersionProvider);
